import { createTheme } from '@mui/material/styles';

import palette from './palette';
import customComponents from './custom-components';
import space from './space';
import typography, { fontWeight } from './typography';
import dimension from './dimension';

const theme = createTheme({
  palette,
  customComponents,
  space,
  typography,
  dimension,
  components: {
    MuiMenu: {
      styleOverrides: {
        list: {
          padding: 0,
        },
        paper: {
          marginTop: '5px',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        colorPrimary: {
          border: 'solid 1px',
          backgroundColor: 'primary.contrast50',
          borderColor: 'primary.main',
        },
        colorSecondary: {
          backgroundColor: 'brown',
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          padding: '12px',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: fontWeight.semiBold,
        },
      },
    },
  },
});

export default theme;
